<template>
  <div class="modal-wrapper">
    <div class="modal-backdrop"></div>
    <div class="modal-inner">
      <div class="edit-popup edit-popup--partners">
        <div class="edit-popup__header">
          <div class="edit-popup__title">
            {{ currentPartner.type === 'new' ? 'Add' : 'Edit' }} Partner
          </div>
          <div @click="closeModalPartner" class="edit-popup__close">
            <svg width="1em" height="1em" class="icon icon-close">
              <use
                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
            </svg>
          </div>
        </div>

        <form action="javascript:void(0)" class="edit-popup--partner__form">
          <div class="row row-first">
            <div class="form-control-group">
              <span class="form-control-label">Company Name:</span>
              <div
                :class="[
                  'form-control-wrap',
                  {'is-error': validateForm.isCompanyName},
                ]">
                <input
                  type="text"
                  v-model="currentPartner.companyName"
                  Placeholder="Company Name"
                  class="form-control" />
              </div>
            </div>
            <div class="form-control-group">
              <span class="form-control-label">Short Name:</span>
              <div
                :class="[
                  'form-control-wrap',
                  {'is-error': validateForm.isShortName},
                ]">
                <input
                  type="text"
                  Placeholder="7S"
                  v-model="currentPartner.shortName"
                  class="form-control" />
              </div>
            </div>
          </div>
          <div class="row row-second">
            <div class="form-control-group">
              <span class="form-control-label">TIN:</span>
              <div :class="['form-control-wrap']">
                <input
                  type="text"
                  v-model="currentPartner.tin"
                  Placeholder="XXX-XXX-XXX"
                  class="form-control" />
              </div>
            </div>
            <div class="form-control-group">
              <span class="form-control-label">VRN:</span>
              <div :class="['form-control-wrap']">
                <input
                  type="text"
                  v-model="currentPartner.vrn"
                  Placeholder="XX-XXXXXX-X"
                  class="form-control" />
              </div>
            </div>
          </div>
          <div class="row row-third">
            <div class="form-control-group">
              <span class="form-control-label">Phone</span>
              <div
                :class="[
                  'form-control-wrap',
                  {'is-error-validate': validateForm.isPhone},
                ]">
                <app-phone
                  v-model="currentPartner.phone"
                  @countryCodeParams="countryCode"
                  placeholder="Start typing the number" />
              </div>
            </div>
          </div>
          <div class="row row-fourth">
            <div class="form-control-group">
              <span class="form-control-label">Address:</span>
              <div :class="['form-control-wrap']">
                <textarea
                  style="resize: none"
                  type="text"
                  v-model="currentPartner.address"
                  class="form-control" />
              </div>
            </div>
          </div>
          <div class="row row-btn">
            <div class=""></div>
            <div class="form-control-group">
              <button
                @click="changePartner"
                type="button"
                class="btn btn--green">
                <span>{{
                  currentPartner.type === 'new' ? 'Add Partner' : 'Edit change'
                }}</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import AppPhone from '@/components/AppPhone'
export default {
  name: 'ATModalPartners',
  props: {
    currentPartner: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      validateForm: {
        isCompanyName: false,
        isShortName: false,
        isCountryCode: false,
        isPhone: false,
      },
    }
  },

  components: {
    AppPhone,
  },
  methods: {
    closeModalPartner() {
      this.$emit('closeModalPartnerParameters', false)
    },
    changePartner() {
      this.validateForm.isCompanyName =
        !this.currentPartner.companyName.length > 0
      this.validateForm.isShortName = !this.currentPartner.shortName.length > 0
      this.validateForm.isPhone = !this.currentPartner.phone.length > 0

      if (
        this.currentPartner.companyName.length > 0 &&
        this.currentPartner.shortName.length > 0 &&
        this.currentPartner.phone.length > 0
      ) {
        this.$emit('changePartnerParameters', this.currentPartner)
        this.closeModalPartner()
      }
    },
    countryCode(value) {
      this.currentPartner.countryCode = value.country.iso2
    },
  },
  mounted() {},
}
</script>
